import { Plus } from 'lucide-react';
import Button from '@components/common/Button';
import { SearchableSelect } from '@components/common/SearchableSelect';
import type { DashboardResponse } from '../../../types/analytics';

interface Props {
  dashboards: DashboardResponse[];
  activeId: string | null;
  canCreate: boolean;
  onSelect: (id: string) => void;
  onCreate: () => void;
}

export function DashboardPicker({ dashboards, activeId, canCreate, onSelect, onCreate }: Props) {
  return (
    <div className="flex items-center gap-2">
      <SearchableSelect
        className="min-w-[220px]"
        value={activeId ?? ''}
        onChange={onSelect}
        aria-label="Select dashboard"
        options={dashboards.map((dashboard) => ({
          id: dashboard.id,
          label: dashboard.access_level === 'owner' ? dashboard.name : `${dashboard.name} (Shared)`,
        }))}
        placeholder="Select dashboard"
        clearable={false}
      />
      {canCreate && (
        <Button size="sm" onClick={onCreate}>
          <Plus className="h-4 w-4" aria-hidden="true" />
          New dashboard
        </Button>
      )}
    </div>
  );
}
